import postsNew from './posts/new';
import postsEdit from './posts/edit';
import profilesEdit from './profiles/edit';

export const configureRoutes = () => {
  const routes = new Map();
  routes.set('posts-new', postsNew);
  routes.set('posts-edit', postsEdit);
  routes.set('profiles-edit', profilesEdit);

  return routes;
};
